import { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { useBreadcrumb } from "../../contexts/BreadcrumbContext.jsx";
import ObjectsTable from "../../components/tables/ObjectsTable.jsx";
import {
  ContentDialog,
  ContentDialogInit,
} from "../../components/MDDForm/components/ContentDialog.jsx";
import { Form, FormRenderer } from "../../components/MDDForm/MDDForm.jsx";
import { fdefObjekt, fdefObjektCreate } from "../../formdefs/objekt.js";
import {
  getRWObjectCopy,
  disableControls,
} from "../../components/MDDForm/helper.js";
import { backendGet } from "../../services/dataService.js";
import { useObjectActions } from "../../hooks/useObjectActions.jsx";

/**
 * Objects List Page
 * Shows a list of objects
 */
export default function ObjectIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const { openCD, setOpenCD, tca, setTca, CDActions, setCDActions } =
    ContentDialogInit();
  const { createOrUpdateObject } = useObjectActions();
  const [isLoadingObject, setIsLoadingObject] = useState(false);

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Objekte", path: "/admin/objekte" },
    ]);
  }, [setBreadcrumbs]);

  const closeDialog = () => {
    setOpenCD(false);
  };

  const openEditObjectModal = (row = {}) => {
    const getData = async () => {
      await backendGet("data/objekts/" + row.id, {
        label: "Objekt",
        setResult: (res) => {
          let fdef = getRWObjectCopy(fdefObjekt);
          if (row.id_ov !== null) {
            fdef.formdefinition = disableControls(fdef.formdefinition);
          }
          showEditCreateModal(
            getRWObjectCopy(res.data),
            fdef,
            "Objekt bearbeiten"
          );
        },
        setIsLoading: setIsLoadingObject,
        options: {
          params: {
            api_version: "v2",
            include: ["sparten", "vertrag"],
          },
        },
      });
    };
    getData();
  };

  const openCreateObjectModal = () => {
    let fdef = getRWObjectCopy(fdefObjektCreate);
    showEditCreateModal({}, fdef, "Objekt erstellen");
  };

  const showEditCreateModal = (model, fdef, title) => {
    setOpenCD(true);
    setTca({
      title: title,
      content: (
        <Form>
          <FormRenderer
            fdef={fdef}
            model={model}
            variant="filled"
            editMode={true}
            showActions={false}
            showCancel={true}
            showToggleEdit={false}
            showErrorText={true}
            actionsPosition="bottom"
            apiGet={backendGet}
            cancelAction={closeDialog}
            submitAction={{
              method: "callback",
              callback: async (formData) => {
                await createOrUpdateObject(formData, {
                  onSuccess: () => {
                    closeDialog();
                  },
                });
              },
            }}
            setActions={setCDActions}
          />
        </Form>
      ),
      actions: null,
    });
  };

  return (
    <>
      <Box>
        <ObjectsTable
          pageTitle="Objekte"
          pageSubtitle="Übersicht aller Objekte"
          onRowClick={openEditObjectModal}
          onClickNew={openCreateObjectModal}
        />
      </Box>
      <ContentDialog
        openCD={openCD}
        setOpenCD={setOpenCD}
        CDActions={CDActions}
        tca={tca}
      />
    </>
  );
}
